import EsgPlatform from './EsgPlatform';

export default EsgPlatform;
